import { createRoleHttpRepository } from '@src/main/modules/roles/infrastructure/RoleHttpRepository';
import { TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

export const deleteRoleUseCase = async (
  id: string,
  tokenProvider: TokenProvider,
): Promise<void> => {
  const repository = createRoleHttpRepository(tokenProvider);
  await repository.delete(id);
};
